import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/api";

const NewsletterForm = ({ dark = true }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email: email.trim() });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Une erreur est survenue. Vérifiez votre adresse e-mail et réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex w-full max-w-md gap-2">
      <label htmlFor="newsletter-email" className="sr-only">
        Votre adresse e-mail
      </label>
      <input
        id="newsletter-email"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Votre adresse e-mail"
        data-testid="newsletter-email-input"
        className={`min-w-0 flex-1 rounded-full px-5 py-3 text-sm font-medium outline-none transition-shadow focus:ring-2 focus:ring-[#38BDF8] ${
          dark
            ? "bg-white/10 text-white placeholder:text-white/50 border border-white/20"
            : "bg-white text-slate-800 placeholder:text-slate-400 border border-slate-300"
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit-button"
        className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[#FF6B6B] px-5 py-3 text-sm font-bold text-white transition-[background-color,transform] duration-200 hover:bg-[#E05252] hover:-translate-y-0.5 disabled:opacity-60"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
        <span className="hidden sm:inline">S'inscrire</span>
      </button>
    </form>
  );
};

export default NewsletterForm;
